<script>
export default {
  props: {
    text: String,
    title: {
      type: String,
      default: null,
    },
    confirmText: {
      type: String,
      default: null,
    },
    confirmVariant: {
      type: String,
      default: 'danger', // 'danger' (red) | 'success' (green)
    },
    value: Boolean,
  },

  computed: {
    dialog: {
      get: (vm) => vm.value,
      set(v) {
        this.$emit("input", v);
      },
    },
  },

  methods: {
    onAccept() {
      this.$emit("accept");
      this.dialog = false;
    },
  },
};
</script>

<template>
  <v-dialog v-model="dialog" max-width="480" content-class="confirm-modal">
    <v-card class="confirm-card" :style="{ borderRadius: '16px' }">
      <div class="confirm-header">
        <h3 class="confirm-heading">{{ title || $t('Confirm') }}</h3>
      </div>
      <div class="confirm-body">
        <p class="confirm-desc">{{ text }}</p>
      </div>
      <div class="confirm-footer">
        <button class="confirm-btn confirm-btn--cancel" @click="dialog = false">
          {{ $t("Cancel") }}
        </button>
        <button :class="['confirm-btn', confirmVariant === 'success' ? 'confirm-btn--success' : 'confirm-btn--confirm']" @click="onAccept">
          {{ confirmText || $t('Yes') }}
        </button>
      </div>
    </v-card>
  </v-dialog>
</template>

<style>
/* ─── Confirm Modal ─── */
.confirm-card {
  padding: 0 !important;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,.12) !important;
  border: 1px solid #e5e7eb;
}

.confirm-card,
.confirm-card * {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

.confirm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.confirm-heading {
  font-size: 1.1rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.confirm-body {
  padding: 20px;
}

.confirm-desc {
  font-size: .95rem;
  color: #4b5563;
  margin: 0;
  line-height: 1.5;
}

.confirm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e5e7eb;
}

.confirm-btn {
  padding: 10px 14px;
  border-radius: 12px;
  font-size: .9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all .15s ease;
  outline: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.confirm-btn--cancel {
  background: #fff;
  color: #111827;
  border: 1.5px dashed #d1d5db;
}

.confirm-btn--cancel:hover {
  border-color: #00274c;
  color: #00274c;
}

.confirm-btn--confirm {
  background: #dc2626;
  color: #fff;
  border: none;
}

.confirm-btn--confirm:hover {
  opacity: .9;
}

.confirm-btn--success {
  background: #16a34a;
  color: #fff;
  border: none;
}

.confirm-btn--success:hover {
  opacity: .9;
}

/* Dark mode confirm modal */
.theme--dark .confirm-card {
  background: #1a1b23 !important;
  border-color: #2a2c3a;
  box-shadow: 0 10px 30px rgba(0,0,0,.4) !important;
}

.theme--dark .confirm-header {
  border-bottom-color: #2a2c3a;
}

.theme--dark .confirm-heading {
  color: #e4e5eb;
}

.theme--dark .confirm-body {
  background: #1a1b23;
}

.theme--dark .confirm-desc {
  color: #d5d6de;
}

.theme--dark .confirm-footer {
  border-top-color: #2a2c3a;
}

.theme--dark .confirm-btn--cancel {
  background: #1a1b23;
  color: #d5d6de;
  border-color: #2a2c3a;
}

.theme--dark .confirm-btn--cancel:hover {
  border-color: #ffd451;
  color: #ffd451;
}
</style>
